<template lang="pug">
b-container.dsg-page(fluid)
    .dsg-page-header
        div
            h1.dsg-page-title
                Icon(icon="ph:calendar-check")
                | Master Schedule
            p.dsg-page-subtitle All active recurring session templates
        .dsg-search
            Icon.dsg-search-icon(icon="mdi:magnify" width="18")
            b-input(placeholder="Search name" type="text" v-model="inputSearchItemList")

    .dsg-table-wrap
        b-table.dsg-table(
            :fields="tableFields"
            :items="scheduleList"
            responsive
            hover
            show-empty
        )
            template(#empty="scope")
                .dsg-empty(v-if="isFetchingAdminDashboardData")
                    b-spinner(variant="primary")
                .dsg-empty(v-else)
                    Icon.dsg-empty-icon(icon="ph:calendar-x" width="48")
                    p.mb-0 No active master schedules found
            template(#cell(scheduleName)="data")
                span.dsg-link(
                    v-b-tooltip.hover :title="`Click to view ${data.item.crb5c_session_id} schedule`"
                    @click="redirectToMasterSchedulePowerApps(data.item.crb5c_fow_session_scheduleid)"
                ) {{ data.item.crb5c_session_id }}
            template(#cell(Time)="data")
                span {{ data.item.crb5c_time_hrs }}:{{ data.item.crb5c_time_mins }}
            template(#cell(Duration)="data")
                span {{ data.item.formattedDuration }}
            template(#cell(createdOn)="data")
                span {{ data.item.formattedCreateOn }}

    p.dsg-count Total master schedule: {{ scheduleList.length }}
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { Icon } from '@iconify/vue2'
import { ADMIN_DASHBOARD_NAMESPACE } from '../../store/Modules/AdminDashboard/types-admin-dashboard'

export default {
    components: {
        Icon,
    },
    data() {
        return {
            tableFields: [
                { 
                    key: "scheduleName", 
                    label: "Schedule Name",
                },
                "Time",
                "Duration",
                { 
                    key: "createdOn", 
                    label: "Created On",
                },
            ],
            inputSearchItemList: '',
            schedules: [],
            scheduleDB: [],
            formattedTime: '',
            selectDay: [
                { 
                    text: 'Monday', 
                    value: 'Monday' 
                },
                { 
                    text: 'Tuesday', 
                    value: 'Tuesday' 
                },
                { 
                    text: 'Wednesday', 
                    value: 'Wednesday' 
                },
                { 
                    text: 'Thursday', 
                    value: 'Thursday' 
                },
                { 
                    text: 'Friday', 
                    value: 'Friday' 
                }
            ],
            daySelectedAll: []
        }
    },
    computed: {
        ...mapState({
          listMasterScehdule: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listMasterScehdule),
          isFetchingAdminDashboardData: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.isFetchingAdminDashboardData),
        }),
        scheduleList(){
            // if(this.inputSearchItemList.trim().length > 0){
            //     return this.scheduleDB.filter((schedule) => {
            //         return schedule.scheduleName.some((item) => {
            //             return item.name.toLowerCase().includes(this.inputSearchItemList.trim().toLowerCase());
            //         });
            //     })
            // }else{
            //     return this.scheduleDB
            // }
            let filteredClients = this.listMasterScehdule;
            if(this.inputSearchItemList.trim().length > 0){
                const searchName = this.inputSearchItemList.trim().toLowerCase();
                filteredClients = filteredClients.filter(client => client.crb5c_session_id.toLowerCase().includes(searchName))
            }
            return filteredClients
        }
        
    },
    methods: {
        backAdminHomepage() {
            this.$router.push({ path: '/adminhomepage' })
        },
        moveToHomePage(){
            this.$router.push({ path: "/" })
        },
        async getScheduleDB(){
            try{
                console.log("Master Schedule Mounted")
                const { data : data } = await axios.get('/api/admin_dashboard/get_session_schedule')
                return data
            } catch (error){
                console.log(error)
                return []
            }
        },
        // eslint-disable-next-line no-unused-vars
        redirectToMasterSchedulePowerApps(crb5c_fow_session_schedule){
            const BASE_URL = `https://${this.$store.state.logindata.DATAVERSE_DOMAIN}`;
            const masterScheduleUrl = `${BASE_URL}/main.aspx?appid=d951a007-cf7a-ed11-81ac-000d3a85cc97&pagetype=entityrecord&etn=crb5c_fow_session_schedule&id=${crb5c_fow_session_schedule}`;

            window.open(masterScheduleUrl, '_blank')
            
        },
    },
    async mounted() {},
    
    
}
</script>

<style scoped>
/* Master schedule uses shared .dsg-* theme (admin-theme.css) */
.dsg-search {
    min-width: 260px;
}
</style>